import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [modo, setModo] = useState('login'); // 'login' ou 'esqueci'
  const [aviso, setAviso] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro(''); setLoading(true);
    try {
      const data = await api.post('/auth/login', { email, senha });
      // Passar userData da API para evitar encoding errado do JWT
      login(data.token, data.user);
      const destino = data.user.role === 'mentor' ? '/mentor/dashboard'
        : data.user.role === 'mentor_fornecedores' ? '/mentor/fornecedores'
        : '/dashboard';
      navigate(destino);
    } catch (err) {
      setErro(err.message);
    } finally { setLoading(false); }
  };

  const pedirLink = async (e) => {
    e.preventDefault();
    setErro(''); setAviso(''); setLoading(true);
    try {
      const data = await api.post('/senha/esqueci', { email });
      setAviso(data.mensagem);
    } catch (err) {
      setErro(err.message);
    } finally { setLoading(false); }
  };

  const trocarModo = (novo) => { setModo(novo); setErro(''); setAviso(''); };

  return (
    <div style={{display:'flex',height:'100vh',overflow:'hidden'}}>
      <div style={{flex:1,background:'#0B0E1A',display:'flex',flexDirection:'column',justifyContent:'center',padding:64}}>
        <div style={{fontSize:12,fontWeight:600,color:'#1A2ECC',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:12}}>Cockpit do Importador</div>
        <h1 style={{fontSize:36,fontWeight:700,color:'#fff',letterSpacing:'-.03em',lineHeight:1.15,marginBottom:16}}>O sistema operacional<br/>da sua importação.</h1>
        <p style={{fontSize:15,color:'rgba(255,255,255,.5)',lineHeight:1.65,maxWidth:380}}>Acompanhe cada fase, conquiste medalhas, tire dúvidas com a IA do Guilherme e avance com quem está na mesma jornada.</p>
        <div style={{display:'flex',gap:32,marginTop:40}}>
          {[['80+','Mentorados ativos'],['8','Fases do método'],['24h','IA disponível']].map(([n,l])=>(
            <div key={l}><div style={{fontSize:28,fontWeight:700,color:'#fff'}}>{n}</div><div style={{fontSize:12,color:'rgba(255,255,255,.4)',marginTop:2}}>{l}</div></div>
          ))}
        </div>
      </div>

      <div style={{width:440,background:'#fff',display:'flex',flexDirection:'column',justifyContent:'center',padding:56}}>
        {modo === 'esqueci' ? (
          <>
            <h2 style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em',marginBottom:6}}>Esqueci minha senha</h2>
            <p style={{fontSize:13,color:'#6B7289',marginBottom:28}}>Digite o e-mail do seu cadastro. Enviaremos um link para você criar uma nova senha.</p>
            <form onSubmit={pedirLink}>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:6}}>Email</label>
                <input className="input-field" type="email" placeholder="seu@email.com" value={email} onChange={e=>setEmail(e.target.value)} required />
              </div>
              {aviso && <div style={{background:'#E6F7F1',border:'0.5px solid #B8E6D2',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#0A6B47',marginBottom:14}}>{aviso}</div>}
              {erro && <div style={{background:'#FDEAEA',border:'0.5px solid #E8A5A5',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#922020',marginBottom:14}}>{erro}</div>}
              <button className="btn-primary" type="submit" disabled={loading} style={{width:'100%',padding:14,fontSize:14}}>
                {loading ? 'Enviando...' : 'Enviar link →'}
              </button>
            </form>
            <button type="button" onClick={()=>trocarModo('login')}
              style={{marginTop:16,background:'none',border:'none',cursor:'pointer',color:'#1A2ECC',fontSize:13,fontWeight:500,textAlign:'center'}}>
              ← Voltar para o login
            </button>
          </>
        ) : (
        <>
        <h2 style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em',marginBottom:6}}>Bem-vindo de volta</h2>
        <p style={{fontSize:13,color:'#6B7289',marginBottom:28}}>Entre com suas credenciais para acessar o cockpit.</p>

        <form onSubmit={handleSubmit}>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:6}}>Email</label>
            <input className="input-field" type="email" placeholder="seu@email.com" value={email} onChange={e=>setEmail(e.target.value)} required />
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:6}}>Senha</label>
            <div style={{position:'relative'}}>
              <input
                className="input-field"
                type={mostrarSenha ? 'text' : 'password'}
                placeholder="••••••••"
                value={senha}
                onChange={e=>setSenha(e.target.value)}
                required
                style={{paddingRight:44}}
              />
              <button type="button" onClick={()=>setMostrarSenha(!mostrarSenha)}
                style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'#9095A8',fontSize:12}}>
                {mostrarSenha ? 'Ocultar' : 'Ver'}
              </button>
            </div>
          </div>

          {erro && <div style={{background:'#FDEAEA',border:'0.5px solid #E8A5A5',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#922020',marginBottom:14}}>{erro}</div>}

          <button className="btn-primary" type="submit" disabled={loading} style={{width:'100%',padding:14,fontSize:14}}>
            {loading ? 'Entrando...' : 'Entrar →'}
          </button>
        </form>
        <button type="button" onClick={()=>trocarModo('esqueci')}
          style={{marginTop:16,background:'none',border:'none',cursor:'pointer',color:'#1A2ECC',fontSize:13,fontWeight:500,textAlign:'center'}}>
          Esqueci minha senha
        </button>
        </>
        )}
      </div>
    </div>
  );
}
